import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import Transition from './transition';

export default class ModalTransition extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    timeout: PropTypes.number,
    className: PropTypes.string,
  };

  render() {
    // @ts-ignore
    const { appear, ...transitionProps } = this.props;

    return (
      <Transition
        {...transitionProps}
        // @ts-ignore
        timeout={this.props.timeout}
        // @ts-ignore
        className={cx(this.props.className, 'modal-transition')}
        exitedClassName="exited"
        exitingClassName="exiting"
        enteredClassName="entered"
        enteringClassName="entering"
      >
        {this.props.children}
      </Transition>
    );
  }
}
